import React from "react";
import { Box, Typography } from "@mui/material";
import { Alert } from "@components/Alert/Alert";
import type { LatestRejection } from "@services/drybulkCargoOperationsApi";
import { convertUtcToUae, formatDateToDDMMYYYY } from "@utils/date-time";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.rejection`;

/**
 * DBCO-0036 (AD-66) - the latest rejection of a Rejected operation: the reason as plain text with its line breaks, who
 * rejected it and when (UAE time). The server sends it only while the status is REJECTED and only to the Shipping Agent
 * and Operations; the host shows this banner only then.
 */
const RejectionReasonBanner: React.FC<{ rejection: LatestRejection }> = ({ rejection }) => {
  const { t } = useTranslation();
  return (
    <Box data-testid="drybulk-cargo-operation-rejection">
      <Alert type="error">
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 1 }}>
          <Typography variant="subtitle2" component="p">
            {t(`${L}.title`)}
          </Typography>
          <Typography
            variant="body2"
            component="p"
            data-testid="drybulk-cargo-operation-rejection-reason"
            sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
          >
            {rejection.reason}
          </Typography>
          <Typography
            variant="caption"
            component="p"
            data-testid="drybulk-cargo-operation-rejection-meta"
          >
            {`${rejection.rejectedBy} · ${formatDateToDDMMYYYY(convertUtcToUae(rejection.rejectedAt), true)}`}
          </Typography>
        </Box>
      </Alert>
    </Box>
  );
};

export default RejectionReasonBanner;
